import { render } from "./Satvis.vue?vue&type=template&id=224bb9b9"
import script from "./Satvis.vue?vue&type=script&lang=js"
export * from "./Satvis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__